import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-blob-version-selector',
    templateUrl: './blob-version-selector.component.html',
    styleUrls: ['./blob-version-selector.component.scss'],
    standalone: false
})
export class BlobVersionSelectorComponent {
    searchText: string;

    public builderName: string;
    public vesselName: string;
    public verionList: string[];
    public filteredVersions: string[];

    constructor(
        public dialogRef: MatDialogRef<BlobVersionSelectorComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.verionList = data.versionList;
        this.builderName = data.builderName;
        this.vesselName = data.vesselName;
        this.filteredVersions = this.verionList ? this.verionList : [];
    }

    filterVersions(event) {
        const searchText = event.currentTarget.value;
        this.filteredVersions = this.verionList.filter((version) => version.includes(searchText));
    }

    rowClick = (p) => {
        this.dialogRef.close(p);
    };
}
